module.exports = __webpack_public_path__ + "static/media/1_Pair-QR-Code-Large.e56bcfc6.svg";